export default function SwishLogo({ className = "h-6", dark = false }) {
  return (
    <svg viewBox="0 0 150 40" className={className} role="img" aria-label="Swish" data-testid="swish-logo">
      <defs>
        <linearGradient id="swishA" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FFC700" />
          <stop offset="0.5" stopColor="#FF4E9B" />
          <stop offset="1" stopColor="#6E2BFF" />
        </linearGradient>
        <linearGradient id="swishB" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#00E0FF" />
          <stop offset="1" stopColor="#8FD400" />
        </linearGradient>
      </defs>
      <path d="M20 4a16 16 0 0 1 12.6 25.9l-4.4-3.4A10.5 10.5 0 0 0 20 9.5z" fill="url(#swishA)" />
      <path d="M20 36A16 16 0 0 1 7.4 10.1l4.4 3.4A10.5 10.5 0 0 0 20 30.5z" fill="url(#swishB)" />
      <text x="42" y="28" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fontSize="24" fill={dark ? "#ffffff" : "#1a1a1a"} letterSpacing="-0.5">swish</text>
      <text x="112" y="16" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fill={dark ? "#ffffff" : "#1a1a1a"}>®</text>
    </svg>
  );
}
